import React, {useState} from "react";
import MediaTable from "./MediaTable/MediaTable";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../../utils/utils"

function DtecFlexCard(props) {

    const [expanded, setExpanded] = useState(false);
    const [firstTime, setFirstTime] = useState(true);

    const { dtec_flex_data } = props
    let initialExpand = dtec_flex_data.flag !== "positive"

    if (initialExpand !== expanded && firstTime === true) {
        setExpanded(initialExpand);
    }
    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    const data = dtec_flex_data.data || {}
    const news_list = data.news_list || []
    const total_results = data.total_results != null ? data.total_results : news_list.length

    const news_with_activity = news_list.find((news) => news.activity)
    const activity = news_with_activity ? news_with_activity.activity : null

    const has_government_involvement = news_list.some((news) => news.government_involvement === true)
    const government_involvement_informed = news_list.some((news) => news.government_involvement !== undefined && news.government_involvement !== null)

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    DTEC-flex
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(dtec_flex_data.flag)}
                </div>
                {data.length === 0 ? null :
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>
                }
            </div>
            {data.length === 0 ? null :
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div className="normalText normalMediumSize" style={{marginTop: "8px"}}>
                    <span style={{fontWeight: "bold", color: "#0b1f82", marginRight: "8px", fontSize: "16px"}}>Crimes:</span>
                    {(data.crimes || "").trim().replace(/^,+|,+$/g, '').replaceAll(',', ', ')}
                </div>

                <div className="normalText normalMediumSize" style={{marginTop: "8px"}}>
                    <span style={{fontWeight: "bold", color: "#0b1f82", marginRight: "8px", fontSize: "16px"}}>Total de notícias:</span>
                    {total_results}
                </div>

                {data.pep === undefined || data.pep === null ? null :
                <div className="normalText normalMediumSize" style={{marginTop: "8px"}}>
                    <span style={{fontWeight: "bold", color: "#0b1f82", marginRight: "8px", fontSize: "16px"}}>PEP:</span>
                    {data.pep ? "Sim" : "Não"}
                </div>
                }

                {activity === null ? null :
                <div className="normalText normalMediumSize" style={{marginTop: "8px"}}>
                    <span style={{fontWeight: "bold", color: "#0b1f82", marginRight: "8px", fontSize: "16px"}}>Atividade:</span>
                    {activity}
                </div>
                }

                {government_involvement_informed === false ? null :
                <div className="normalText normalMediumSize" style={{marginTop: "8px"}}>
                    <span style={{fontWeight: "bold", color: "#0b1f82", marginRight: "8px", fontSize: "16px"}}>Envolvimento com governo:</span>
                    {has_government_involvement ? "Sim" : "Não"}
                </div>
                }

                <div
                    className={["blueText", "bold"].join(" ")}
                    style={{margin:"auto 0px", fontSize: "16px", marginTop: "32px"}}
                >
                    Mídias
                </div>
                <div
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    <MediaTable news={news_list}/>
                </div>
            </Collapse>
            }
        </div>
        );
}

export default DtecFlexCard
